import { createListAction } from '../../../shared/lib/listHelpers';

export const getEdgeTasks = (rows) => createListAction(rows);
